import { render } from "./InstantSearch.vue?vue&type=template&id=a0c8899a"
import script from "./InstantSearch.vue?vue&type=script&lang=js"
export * from "./InstantSearch.vue?vue&type=script&lang=js"

import "./InstantSearch.vue?vue&type=style&index=0&id=a0c8899a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__